import React from 'react';

export default function SchoolN() {
  return <svg viewBox="0 0 100 100" aria-hidden="true" data-testid="school-n" fill="none"
    stroke="currentColor" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round">
    <path d="M25 80V28M25 52C25 20 75 20 75 52V80" />
  </svg>;
}
